export const CLEAR_STATE_ACTION_TYPE = 'CLEAR_STATE_ACTION_TYPE';
